import React from "react";
import { User, ShieldCheck, Search, MessageSquare, FileText, Plane, Home } from "lucide-react";
import Reveal from "./Reveal";
import { HOWITWORKS_IMG } from "./data";
import { useT } from "./i18n";

const ICONS = [User, ShieldCheck, Search, MessageSquare, FileText, Plane, Home];

export default function HowItWorks() {
  const { t } = useT();
  return (
    <section id="how" className="scroll-mt-24 bg-[#173A2C] py-20 text-white">
      <div className="mx-auto max-w-6xl px-5">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_.9fr]">
          <div>
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.22em] text-[#C4A46B]">{t.how.eyebrow}</p>
              <h2 className="mt-3 max-w-lg font-serif text-4xl leading-tight sm:text-5xl">{t.how.heading}</h2>
              <p className="mt-3 max-w-md text-base text-white/70">{t.how.sub}</p>
            </Reveal>

            <ol className="mt-10 space-y-1">
              {t.how.steps.map(([title, desc], i) => {
                const Icon = ICONS[i];
                return (
                  <Reveal as="li" key={title} delay={(i % 3) + 1} className="relative flex gap-4 border-l border-white/15 pb-6 pl-6 last:pb-0">
                    <span className="absolute -left-[17px] top-0 flex h-8 w-8 items-center justify-center rounded-full bg-[#C4A46B] text-[#173A2C]">
                      <Icon className="h-4 w-4" />
                    </span>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-semibold text-[#C4A46B]">{String(i + 1).padStart(2, "0")}</span>
                        <h3 className="text-base font-semibold">{title}</h3>
                      </div>
                      <p className="mt-1 text-sm leading-relaxed text-white/70">{desc}</p>
                    </div>
                  </Reveal>
                );
              })}
            </ol>
          </div>

          <Reveal delay={2} className="relative hidden overflow-hidden rounded-3xl lg:block">
            <img src={HOWITWORKS_IMG} alt="Leading horses down a tree-lined lane" loading="lazy" decoding="async" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#173A2C]/50 to-transparent" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
